<template>
  <div class="main-cnt">
    <Nav />
    <let-it-snow v-bind="snowConf" :show="show"></let-it-snow>
    <b-container class="home-cnt">
      <h3 class="welcome-text">Happy Holidays from the Arizona Cardinals</h3>
      <div class="map-cnt">
        <div class="map">
          <!-- <div class="zoom-buttons">
            <b-button @click="$refs.zoomer.zoomIn()">
              <img src="@/assets/images/icons/map/zoom-in.svg" alt="Zoom In" />
            </b-button>
            <b-button @click="$refs.zoomer.zoomOut()">
              <img
                src="@/assets/images/icons/map/zoom-out.svg"
                alt="Zoom Out"
              />
            </b-button>
          </div> -->
          <image-zoom
            regular="https://cardinals.vipfanportal.com/2021holidays/files/Cardinalville_frame.png"
            zoom="https://cardinals.vipfanportal.com/2021holidays/files/Cardinalville_squish.png"
            :zoom-amount="3"
            :click-zoom="true"
            img-class="img-fluid"
            alt="Cardinalville Map"
          >
          </image-zoom>
          <!-- <img
            id="panzoom-element"
            src="@/assets/images/Cardinalville_-min.jpg"
            style="object-fit: contain; width: 100%; height: 100%"
          /> -->
        </div>
      </div>
      <!-- <b-button class="play-skip-button play-button">
        <div class="button-text-cnt" @click="showVideo">
          <img src="@/assets/images/icons/left-arrow.svg" alt="Left Arrow" />
          <p>Intro Video</p>
        </div>
      </b-button> -->
      <ButtonsBox />
      <Countdown
        startDate="December 15 2021 23:59:59 GMT-0700"
        endDate="December 25 2021 20:15:00 GMT-0700"
      />
      <b-button class="play-skip-button buy-button" @click="showVideo">
        <div class="button-text-cnt">
          <p>Intro Video</p>
        </div>
      </b-button>
    </b-container>
    <transition name="component-fade" mode="out-in">
      <ShareModal v-show="shareModal" />
    </transition>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import Countdown from "@/components/Countdown";
import ButtonsBox from "@/components/ButtonsBox";
import ShareModal from "@/components/ShareModal";
import { mapState } from "vuex";
import imageZoom from "vue-image-zoomer";

export default {
  name: "Home",
  components: { Nav, Countdown, ButtonsBox, ShareModal, imageZoom },
  data() {
    return {
      snowConf: {
        interaction: true,
        windPower: 1,
        speed: 3,
        count: 12,
        size: 20,
        opacity: 1,
        images: [
          "https://cardinals.vipfanportal.com/2021holidays/files/snowflakes/snow-flake-06.svg",
          "https://cardinals.vipfanportal.com/2021holidays/files/snowflakes/snow-flake-09.svg",
          "https://cardinals.vipfanportal.com/2021holidays/files/snowflakes/snow-flake-12.svg",
          "https://cardinals.vipfanportal.com/2021holidays/files/snowflakes/snow-flake-21.svg",
          "https://cardinals.vipfanportal.com/2021holidays/files/snowflakes/snow-flake-38.svg",
          "https://cardinals.vipfanportal.com/2021holidays/files/snowflakes/snow-flake-41.svg",
          "https://cardinals.vipfanportal.com/2021holidays/files/snowflakes/snow-flake-56.svg",
        ],
      },
      show: false,
    };
  },
  computed: {
    ...mapState(["global"]),
    shareModal() {
      return this.$store.getters.getShareModal;
    },
  },
  methods: {
    showVideo() {
      this.$store.dispatch("showVideo");
    },
    showShareModal() {
      this.$store.dispatch("showShareModal");
    },
    hideShareModal() {
      this.$store.dispatch("hideShareModal");
    },
    create_snow_lake() {
      var falling_time = Math.floor(Math.random() * 10) + 5;
      var flake_pos = Math.floor(Math.random() * 90) + 4;
      var flake_size = (Math.floor(Math.random() * 100) + 1) / 100;
      var snow_flake =
        "<div class='flake-wrapper' style='width:40px; left:" +
        flake_pos +
        "%;height:40px;transform:scale(" +
        flake_size +
        ");animation:falling " +
        falling_time +
        "s linear infinite'>" +
        this.flake +
        "</div>";
      snow_flake.appendTo(".main-cnt");
    },
    remove_snow_lake() {
      ".flake-wrapper".each(function () {
        var flake_pos = this.offset().top;
        var body_height = document.height() - 100;
        if (flake_pos > body_height) {
          this.remove();
        }
      });
    },
  },
  mounted() {
    this.show = true;
  },
};
</script>

<style lang="scss" scoped>
.main-cnt {
  z-index: 1;
  // background: url("~@/assets/images/snow-flake-bg.jpg");
  // background-size: 100vw;
  // background-repeat: repeat-y;
  // background-attachment: fixed;
  // background-position: center;
  // background-repeat: no-repeat;
  position: relative;
  .home-cnt {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1000px;
    margin: 0 auto 0;
    .welcome-text {
      color: #ffffff;
      font-family: Gotham;
      font-size: 20px;
      font-weight: 900;
      letter-spacing: 0.71px;
      line-height: 22px;
      margin: 126px 0 26px;
      align-self: flex-start;
      text-transform: uppercase;
    }
    .map-cnt {
      .map {
        position: relative;

        .zoom-buttons {
          display: flex;
          flex-direction: column;
          position: absolute;
          z-index: 1;
          bottom: 10px;
          right: 10px;
          img {
            width: 50px;
            height: auto;
          }
        }
      }
    }
    .play-button {
      align-self: flex-start;
      margin: 33px 0 0 -195px;
      img {
        margin: 0 4px 0 0;
      }
      p {
        margin: 2px 0 0 0;
      }
      @media only screen and (max-width: 1400px) {
        margin: 33px 0 0 0px;
      }
      @media only screen and (max-width: $lg) {
        margin: 33px 0 0 0;
        align-self: center;
      }
    }
    .buy-button {
      margin-top: 45px;
      margin-bottom: 110px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: all 1s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
  /* transform: translate(100vw, 0); */
}
@media only screen and (max-width: $lg) {
  .main-cnt {
    .home-cnt {
    }
  }
}
@media only screen and (max-width: $md) {
  .main-cnt {
    .home-cnt {
    }
  }
}
@media only screen and (max-width: $sm) {
  .main-cnt {
    .home-cnt {
      .welcome-text {
        text-align: left;
      }
    }
  }
}
</style>
